export default __webpack_public_path__ + "static/media/roots-logo2.ff211b33.svg";